import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';
import { resources, defaultNS } from './resources';

i18next.use(initReactI18next).init({
  lng: 'en', // if you're using a language detector, do not define the lng option
  debug: false,
  defaultNS,
  resources,
  ns: ['big', 'generalEN', 'limitsEN', 'dashboardFaceliftResourcesEN , firstImperssionEN', 'inviteEN', 'errorsEN'],
});

export default i18next;
